export const ANALYSIS_REPORT = "ANALYSISREPORT";